"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUndefined = void 0;
var deleteUndefined = function deleteUndefined(obj) {
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'undefined') {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  });
  return obj;
};
exports.deleteUndefined = deleteUndefined;